import React from 'react';
export function Footer() {
  return <footer className="bg-black py-8 border-t border-dark-border text-center px-4" data-id="element-123">
      <div className="max-w-4xl mx-auto" data-id="element-124">
        <p className="text-gold-dark text-sm" data-id="element-125">
          © {new Date().getFullYear()} Mega Pack Bromatología en el Aula —
          Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}